import { Amplify } from "aws-amplify";
import { __LOCAL__, __PRODUCTION__ } from "./app/casehero/shared/consts";
import { cloudWatchLogger, notify } from "./app/casehero/shared/utils";

// Establish Cognito connection
export const initAmplify = () => {
  // Only configure Amplify if environment variables are set (not in tests)
  if (
    process.env.REACT_APP_COGNITO_IDENDITY_POOL_ID &&
    process.env.REACT_APP_COGNITO_REGION &&
    process.env.REACT_APP_COGNITO_USER_POOL_ID &&
    process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID
  ) {
    Amplify.configure({
      Auth: {
        Cognito: {
          identityPoolId: process.env.REACT_APP_COGNITO_IDENDITY_POOL_ID,
          region: process.env.REACT_APP_COGNITO_REGION,
          userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
          userPoolClientId:
            process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
        } as unknown as undefined,
        loginWith: {
          oauth: {
            domain: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN!,
            scopes: [
              "phone",
              "email",
              "openid",
              "aws.cognito.signin.user.admin",
              "profile",
            ],
            redirectSignIn: [window.location.origin + "/oauth"],
            redirectSignOut: [window.location.origin],
            responseType: "code", // Auth code grant
          },
        },
      },
      Storage: {
        S3: {
          bucket: "happy-legal-upload-tmp",
          region: "eu-central-1",
        },
      },
    } as any);
  }

  import("@aws-amplify/auth").then(async (authModule) => {
    const { fetchAuthSession, signOut } = authModule;
    try {
      const session = await fetchAuthSession();
      // Guest credentials are allowed in production, do not throw
      // Only log in non-production
      if (!__PRODUCTION__) {
        console.log("Amplify user sub:", session.userSub);
        console.log("Amplify guest credentials:", session.credentials);
      }
    } catch (err: any) {
      console.error("Could not get Amplify credentials, trying signOut", err);
      try {
        await signOut();
        const session = await fetchAuthSession();
        // Guest credentials are allowed in production, do not throw
        if (!__PRODUCTION__) {
          console.log(
            "Amplify guest credentials after signOut:",
            session.credentials,
          );
        }
      } catch (err2: any) {
        console.error("Still could not get Amplify guest credentials", err2);
        if (__PRODUCTION__) {
          notify(
            "Fehler: Keine Gast-Zugangsdaten verfügbar. Bitte laden Sie die Seite neu oder kontaktieren Sie den Support.",
          );
        }
      }
    }
  });
};

// Disable React Dev Tools
declare global {
  interface Window {
    __REACT_DEVTOOLS_GLOBAL_HOOK__: any;
  }
}
const disableReactDevTools = () => {
  if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ !== "object") return;

  for (const prop in window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    if (prop === "renderers") {
      // Remove console error
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] = new Map();
    } else {
      // Replace all properties with a no-op function or a null value
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] =
        typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] === "function"
          ? () => {
              return;
            }
          : null;
    }
  }
};

// Initialise project
const init = () => {
  initAmplify();

  if (__LOCAL__) return;
  // (dev)-app.happylegal.de:

  // Initialise CloudWatch Logger
  cloudWatchLogger.install({
    logStreamNameResolver() {
      // Create stream name: date, time, user agent
      const logName = `${new Date().toLocaleString()} ${
        window.navigator.userAgent
      }`;

      // Replace disallowed characters
      return Promise.resolve(logName.replaceAll(":", ".").replaceAll("*", ""));
    },
  });

  if (!__PRODUCTION__) return;
  // app.happylegal.de:

  disableReactDevTools();
};

export default init;
